import Wmts from "../Wmts";
import TileLayer from "ol/layer/Tile.js";
import Container from "../../Main/Container.js";

export default class LuchtfotoMip extends Wmts {
    async buildOlLayers(): Promise<TileLayer[]> {
        const labelMip = Container.mapImageProvider('nl_luchtfoto_lufolabels_wmts');

        const parentLayers = await super.buildOlLayers();
        const labelLayers = await labelMip.buildOlLayers();

        return [
            ...parentLayers,
            ...labelLayers,
        ];
    }
}
